<template>
    <div class="mx-auto">
      <div class="vs-con-loading__container">
        <div class="grid grid-cols-1 lg:grid-cols-6 gap-4 overflow-hidden">
          <div class="lg:col-span-3 fixed sticky">
            <action-component :module_name="module_name" @update-submitted="handleUpdateSubmit" ref="actionComponent" />
          </div>

          <div class="lg:col-span-3 overflow-y-auto pr-2" style="max-height: 80vh;">
            <list-component :module_name="module_name" :ref="listComponentRef" @edit-update="handleEditUpdate" />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ActionComponent from './action.vue'
import ListComponent from './list.vue'

export default {
  name: 'GurudwaraUpdateModule',
  components: {
    ActionComponent,
    ListComponent
  },
  data() {
    return {
      module_name: 'Gurudwara Update',
      listComponentRef: 'listComponent'
    }
  },

  methods: {
    handleEditUpdate(updateId) {
      // Access the action component directly
      this.$refs.actionComponent.setEditData(updateId)
    },

    handleUpdateSubmit() {
      // Refresh list data after update
      this.$refs.listComponent.getData()
    }
  }
}
</script>

<style scoped>
/* Ensure full height for the grid */
.container {
  min-height: calc(100vh - 4rem);
}
</style>